import { PageResponse } from '@/shared/interfaces/page-response'
import { updateOrAppend } from '@/shared/utils/list'

export function mergePages<T>(
  oldPage: PageResponse<T>,
  newPage: PageResponse<T>,
  sortItems?: (a: T, b: T) => number
): PageResponse<T> {
  let items: T[] = []

  for (const post of oldPage.items) {
    items = updateOrAppend(items, post)
  }

  for (const post of newPage.items) {
    items = updateOrAppend(items, post)
  }

  if (sortItems != null) {
    items.sort(sortItems)
  }

  return {
    items,
    number: oldPage.number,
    size: items.length,
    total: newPage.total,
  }
}
